// get('/products')
// post('/products', product)
// put('/products/:id', product)
// delete('/products/:id')


// get('/trainers')
// post('/trainers', trainer)
// put('/trainers/:id', trainer)
// delete('/trainers/:id')



// import axios from 'axios'

// export const api = axios.create({
//   // baseURL: import.meta.env.VITE_SERVER_URL, // Replace with your actual API
//   baseURL: "http://localhost/3ibazaaradmin/public/", // Replace with your actual API
//   headers: {
//     'Content-Type': 'application/json',
//     'Access-Control-Allow-Origin': '*'
//   }
// })
// export default api


// after that

import axios from 'axios'
import { useAuthStore } from '@/store/authStore'

const api = axios.create({
 
  // baseURL: process.env.VITE_SERVER_URL || 'http://localhost/3ibazaaradmin/public/',
baseURL:  'https://prod.graddev.in/', // online url
// baseURL:  'http://127.0.0.1:8000/', // local url

})

api.interceptors.request.use(config => {
  const auth = useAuthStore()
  if (auth.token) {
    config.headers.Authorization = `Bearer ${auth.token}`;
  } 
  return config
})

export default api

